module.exports = __webpack_public_path__ + "static/media/zhengs2-0@3x.60f08084.png";